export function isLegislationHealthConcerning(health) {
    if (!health) return false
    if (health.status === "broken" || health.status === "redirect") return true
    return (
        health.status === "ok" &&
        health.contentCheck?.status === "done" &&
        health.contentCheck?.relevant === false &&
        health.contentCheck?.confidence === "high"
    )
}
